import DynamicTypography from "./DynamicTypography"

export default DynamicTypography
